import React from 'react';

export default function NubbiLabInstructions() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white font-sans">

      <header className="flex justify-between items-center px-6 py-4 bg-black sticky top-0 z-50">
        <div className="flex items-center gap-4">
          <img src="/logooficial.png" alt="NubbiLand Logo" className="h-14 rounded-lg" />
          <h1 className="text-2xl font-extrabold text-white">NUBBILAND</h1>
        </div>

        <nav className="flex items-center gap-8">
          <a href="/" className="text-white font-bold hover:text-yellow-400">Home</a>
        </nav>
      </header>

      <section className="flex flex-col items-center text-center py-16 px-4">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-8 drop-shadow-lg">🧪 Nubbi Lab</h1>
        <p className="text-2xl md:text-3xl font-semibold max-w-3xl">
          Create your own Nubbi and join the official Nubbiland Universe!
        </p>
      </section>

      <section className="flex flex-col items-center text-center py-6 px-6">
        <div className="bg-black bg-opacity-50 rounded-xl p-8 max-w-3xl shadow-lg">
          <h2 className="text-3xl font-bold mb-6">How It Works</h2>

          <h3 className="text-2xl font-semibold mb-2">1️⃣ Generate Your Nubbi</h3>
          <p className="mb-6">Use our Nubbi Lab powered by AI to create your unique Nubbi. Describe your character idea in full detail and let our AI bring your vision to life.</p>

          <h3 className="text-2xl font-semibold mb-2">2️⃣ Submit Your Nubbi</h3>
          <p className="mb-2">Once your Nubbi is ready, submit your creation to us:</p>
          <p className="mb-2">📧 <a href="mailto:admin@nubbi.co" className="text-yellow-300 font-bold">admin@nubbi.co</a></p>
          <p className="mb-6">📲 <a href="https://instagram.com/nubbiland" target="_blank" rel="noopener noreferrer" className="text-yellow-300 font-bold">@nubbiland</a></p>

          <h3 className="text-2xl font-semibold mb-2">3️⃣ Review & Upload</h3>
          <p className="mb-6">Our team will review all submissions. If approved, your Nubbi may be featured on Nubbiland or future official projects!</p>

          <p className="italic text-sm text-gray-300">*Submission does not guarantee inclusion. All submissions are carefully reviewed to maintain official Nubbi standards.*</p>

          <a 
            href="https://chatgpt.com/g/g-68478ab45c288191ae16fbe13ec9ada9-nubbi-creator-pro" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block mt-8 px-10 py-4 bg-pink-500 text-white text-2xl font-bold rounded-xl shadow-lg hover:scale-110 transition"
          >
            🚀 Launch Nubbi Lab
          </a>
        </div>
      </section>

      <footer className="bg-black bg-opacity-50 text-center py-6 text-sm">
        📧 Contact: nubbiland@gmail.com
      </footer>
    </div>
  );
}